// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PoL72CeCwXQr2PMF2hA7{align-items:center;width:100%;max-width:760px;padding:8px 38px 8px 20px;display:flex}.V8VTpPqcmEtM9faOXREx{width:35px;color:var(--content-primary-tertiary);margin-right:16px;font-size:13px;font-weight:400}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `PoL72CeCwXQr2PMF2hA7`,
	"label": `V8VTpPqcmEtM9faOXREx`
};
export default ___CSS_LOADER_EXPORT___;
